import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useBoardPermissions } from "~/hooks/useBoardPermissions";
import { useCurrentWorkspacePermissionsContext } from "~/providers/CurrentWorkspacePermissionsProvider";
import { canChangeBoardIntegrationDetails } from "~/utils/permissions/boardPermissions";
import { ConnectedToSlack } from "./components/ConnectedToSlack";
import { ConnectToSlack } from "./components/ConnectToSlack";
export const SlackIntegration = /*#__PURE__*/ memo((param)=>{
    let { integration, board, updateBoardSlackIntegration } = param;
    const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();
    const { boardPermissions } = useBoardPermissions({
        boardId: board.id
    });
    const canManageSlackIntegration = canChangeBoardIntegrationDetails({
        workspaceContext: workspacePermissions,
        boardContext: boardPermissions
    });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "text-14 font-medium text-grey-12",
                children: "Connect to Slack"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-12 text-grey-11",
                children: "Connect this board to a channel in Slack to receive notifications for uploads, board creations, comments, and edits to custom fields."
            }),
            !!integration && /*#__PURE__*/ _jsx(ConnectedToSlack, {
                integration: integration,
                boardId: board.id,
                canManageSlackIntegration: canManageSlackIntegration,
                onUpdate: updateBoardSlackIntegration
            }),
            !integration && canManageSlackIntegration && /*#__PURE__*/ _jsx(ConnectToSlack, {
                board: board
            })
        ]
    });
});
SlackIntegration.displayName = "SlackIntegration";
